// composables/useViewportHeight.js
import { ref, onMounted, onUnmounted } from "vue"

export function useViewportHeight() {
  const vh = ref(window.innerHeight)

  function updateHeight() {
    vh.value = window.innerHeight

    // Optional: update CSS variable too
    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight * 0.01}px`
    )
  }

  onMounted(() => {
    updateHeight()
    window.addEventListener("resize", updateHeight)
    window.addEventListener("orientationchange", updateHeight)
  })

  onUnmounted(() => {
    window.removeEventListener("resize", updateHeight)
    window.removeEventListener("orientationchange", updateHeight)
  })

  return { vh }
}
